export const Modules = {
  clipboard: {
    matchVisual: false,
    matchers: [
      [
        "*",
        (node, delta) => {
          const ops = delta.ops.map((op) => {
            if (op.attributes) {
              delete op.attributes.color;
              delete op.attributes.background;
            }
            // Remove any image insertions
            if (op.insert && typeof op.insert === "object" && op.insert.image) {
              return { insert: "" };
            }
            return op;
          });
          return { ops };
        },
      ],
    ],
  },
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    [{ align: [] }],
  ],
};

export const Formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "link",
  "align",
  "color",
  "code-block",
];
